import {getServerStoreData, setServerStoreData} from '../../services/proto/ServerStorage/service';
import {getStorageKey} from '../../services/proto/ServerStorage/utils';
import {keyParams} from './consts/consts';
import {common} from '@priority-software/priority-proto-api/lib';

export const isAnnouncementNew = async announcementVersion => {
    const key = getStorageKey(keyParams) + `/${announcementVersion}`;
    const res = await getServerStoreData([key], false, true);
    if (Object.keys(res).length) {
        const resStr = res?.[key]?.['Str'];
        if (resStr) {
            return JSON.parse(resStr);
        }
        return false;
    }
    return true;
};

export const setAnnouncementConfirmation = async (
    announcementVersion: string,
    showNextTime: boolean
) => {
    const keyParamsSetter = keyParams;
    const key = getStorageKey(keyParamsSetter) + `/${announcementVersion}`;
    const storeMap = {[key]: new common.Constant({Str: JSON.stringify(showNextTime)})};
    setServerStoreData(storeMap, true, false);
};

(window as any).setAnnouncementConfirmation = setAnnouncementConfirmation;
(window as any).isAnnouncementNew = isAnnouncementNew;
/*
    reopen announcement for testing:
    window.setAnnouncementConfirmation({versionNum: string}, true)
    *** NOTICE: the version of the DEV env is currently 22.01 so the call will be:
    window.setAnnouncementConfirmation('22.01', true)
*/
